module.exports = __webpack_public_path__ + "img/product_3.0b19e87.jpg";